import BuyBillingCurrency from './BuyBillingCurrency';

export default BuyBillingCurrency;
